import { ProductVariationModel as ProductVariationApi } from '@/http/models/Product/ProductVariation'
import { toast } from 'sonner'

import { useCallback, useState } from 'react'

export const useGenerateVariationKeywords = () => {
  const [isGenerating, setIsGenerating] = useState(false)

  const generateKeywords = useCallback(async (productId: string, variationId: string) => {
    setIsGenerating(true)

    try {
      const response = await ProductVariationApi.generateKeywords({
        params: { productId, variationId },
      })

      if (!response.success || !response.data?.result?.keywords) {
        throw new Error(response.error?.data?.message || 'Failed to generate keywords')
      }

      return response.data.result.keywords
    } catch (err: any) {
      toast.error(err.message || 'Failed to generate keywords')
      return null
    } finally {
      setIsGenerating(false)
    }
  }, [])

  return {
    isGenerating,
    generateKeywords,
  }
}
